var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMilkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1535_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0815 4.57877L13.953 2.70727C20.3531 10.3774 10.3854 20.3559 2.70716 13.9531L4.57865 12.0816C4.76103 11.8993 4.76103 11.6036 4.57865 11.4212C4.39628 11.2389 4.10058 11.2389 3.91824 11.4212L2.04675 13.2927C-4.35336 5.6226 5.6144 -4.35586 13.2926 2.04686L11.4211 3.91835C11.2387 4.10073 11.2387 4.39639 11.4211 4.57877C11.6035 4.76114 11.8992 4.76114 12.0815 4.57877ZM10.6839 3.36231C10.6839 3.73423 10.3913 4.03531 10.0241 4.05438C10.1248 4.96514 10.3479 5.48053 10.5587 5.96731C10.8036 6.53284 11.0317 7.05977 11.0317 8.12321V12.2899C11.0317 12.8652 10.5636 13.3333 9.98824 13.3333H6.50997C5.93457 13.3333 5.46649 12.8652 5.46649 12.2899V8.12321C5.46649 7.0612 5.69494 6.53273 5.93995 5.96593C6.15071 5.4784 6.37371 4.96252 6.47413 4.05435C6.10693 4.03531 5.8143 3.73423 5.8143 3.36231C5.8143 2.9781 6.12576 2.66667 6.50997 2.66667H9.98822C10.3724 2.66667 10.6839 2.9781 10.6839 3.36231ZM6.42636 7.77218V12.2899H10.1416V8C9.71782 8.50174 8.99981 8.64897 8.02197 7.77218C7.24167 7.07252 6.42636 7.77218 6.42636 7.77218Z",
    fill: "#6ACEE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1535_1524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMilkFilled);
export default __webpack_public_path__ + "static/media/no_milk_filled.61617d9de80f80fd1c67fc5cdf7e3f49.svg";
export { ForwardRef as ReactComponent };